<div class="totals">
    <div class="totals__container">
      <div class="totals__filters filter" [formGroup]="totalsFilterForm">
        <mat-form-field *ngIf="isDepartmentDisabled" appearance="outline" class="totals__filter">
          <mat-select formControlName="departmentId" placeholder="Agency/Customer">
            <mat-option *ngFor="let option of departmentOptions" [value]="option.value">
              {{option.viewValue}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="totals__filter">
          <mat-label>Enter a date range</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate formControlName="fromDate" placeholder="Start date">
            <input matEndDate formControlName="toDate" placeholder="End date">
          </mat-date-range-input>
          <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
          <mat-error *ngIf="totalsFilterForm.controls['fromDate'].hasError('matStartDateInvalid')">Invalid start date</mat-error>
          <mat-error *ngIf="totalsFilterForm.controls['toDate'].hasError('matEndDateInvalid')">Invalid end date</mat-error>
        </mat-form-field>
        <button class="totals__filter-btn" mat-stroked-button color="primary" (click)="search()" [disabled]="totalsFilterForm.invalid || (loading$ | async)">Apply</button>
        <button mat-button type="button" class="custom-button totals__filter-btn" (click)="clear()" [disabled]="totalsFilterForm.invalid">Clear</button>
      </div>
      <div *ngIf="loading$ | async; else totals" class="totals__loader loading">
        <mat-spinner></mat-spinner>
      </div>
      <ng-template #totals>
        <app-card *ngFor="let item of totalsItems" [showHeader]="false">
          <div class="totals__grid-item">
            <div class="totals__item-value">{{item.value}}</div>
            <div class="totals__item-title">{{item.title}}</div>
          </div>
        </app-card>
      </ng-template>
    </div>
</div>
